import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select';
import { AutoSizer, List } from 'react-virtualized';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import NoSsr from '@material-ui/core/NoSsr';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';
import { emphasize } from '@material-ui/core/styles/colorManipulator';

const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: 2,
        marginBottom: 14,
    },
    input: {
        display: 'flex',
        paddingTop: 6,
        paddingBottom: 7
    },
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center'
    },
    chip: {
        margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`
    },
    chipFocused: {
        backgroundColor: emphasize(
            theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
            0.08,
        ),
    },
    noOptionsMessage: {
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    singleValue: {
        fontSize: 16,
    },
    placeholder: {
        position: 'absolute',
        left: 2,
        fontSize: 16,
    },
    paper: {
        position: 'absolute',
        zIndex: 100,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    danger: {
        color: 'red'
    }
});

function NoOptionsMessage(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.noOptionsMessage}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function inputComponent({ inputRef, ...props }) {
    return <div ref={inputRef} {...props} />;
}

function Control(props) {
    return (
        <TextField
            style={{ width: '90%' }}
            InputProps={{
                inputComponent,
                inputProps: {
                    className: props.selectProps.classes.input,
                    inputRef: props.innerRef,
                    children: props.children,
                    ...props.innerProps,
                },
            }}
            {...props.selectProps.textFieldProps}
        />
    );
}

function Option(props) {
    const optiontype = props.data.optiontype
    return (
        <MenuItem
            buttonRef={props.innerRef}
            selected={props.isFocused}
            component="div"
            style={optiontype === 'frequentData' ? {
                fontWeight: props.isSelected ? 500 : 400,
                color: '#d89797',
            } : {
                    fontWeight: props.isSelected ? 500 : 400
                }}
            {...props.innerProps}
        >
            {props.children}
        </MenuItem>
    );
}

function Placeholder(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.placeholder}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function SingleValue(props) {
    return (
        <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
            {props.children}
        </Typography>
    );
}

function ValueContainer(props) {
    return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
    return (
        <Chip
            tabIndex={-1}
            label={props.children}
            className={classNames(props.selectProps.classes.chip, {
                [props.selectProps.classes.chipFocused]: props.isFocused,
            })}
            onDelete={props.removeProps.onClick}
            deleteIcon={<CancelIcon {...props.removeProps} />}
        />
    );
}

function Menu(props) {
    return (
        <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
            {props.children}
        </Paper>
    );
}

const MenuList = props => {
    const rows = props.children
    const rowRenderer = ({ key, index, style }) => (
        <div key={key} style={style}>{rows[index]}</div>
    )

    const height = rows.length !== undefined ? rows.length * 50 > 200 ? 200 : rows.length * 50 : 0;

    return (
        <AutoSizer disableHeight>
            {({ width }) => (
                <List
                    width={width}
                    height={height}
                    rowCount={rows.length ? rows.length : 0}
                    rowHeight={50}
                    rowRenderer={rowRenderer}
                />
            )}
        </AutoSizer>
    )
}

const components = {
    Control,
    Menu,
    MultiValue,
    NoOptionsMessage,
    Option,
    Placeholder,
    SingleValue,
    ValueContainer,
    MenuList
};

class IntegrationReactSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            single: null,
            multi: null,
            value: props.value,
            options: []
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        var disabledDefaultOptions = this.props.disabledDefaultOptions;
        disabledDefaultOptions = this.props.disabledDefaultOptions === undefined ? false : true;

        var options = this.props.options;
        if (!disabledDefaultOptions) {
            if (options.length > 0) {
                const type = options[0].type;

                const jsondata = {
                    id: '-1',
                    label: '-- SELECT --',
                    type: type
                }

                options.unshift(jsondata)
            }
        }

        this.setState({
            options: options
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                value: nextProps.value,
            })
        }

        if (nextProps.options) {
            var disabledDefaultOptions = this.props.disabledDefaultOptions;
            disabledDefaultOptions = this.props.disabledDefaultOptions === undefined ? false : true;

            var options = nextProps.options;
            if (!disabledDefaultOptions) {
                if (options.length > 0) {
                    const type = options[0].type;

                    const jsondata = {
                        id: '-1',
                        label: '-- SELECT --',
                        type: type
                    }

                    options.unshift(jsondata)
                }
            }

            this.setState({
                options: options
            })
        }
    }

    handleChange = name => value => {
        this.setState({
            [name]: value,
        });

        this.props.handleSelectData(value)
    };

    render() {
        const { classes, theme } = this.props;
        const selectStyles = {
            input: base => ({
                ...base,
                color: theme.palette.text.primary,
                '& input': {
                    font: 'inherit',
                },
                height: '34',
            }),
            menuList: base => ({
                ...base,
                maxHeight: '250px',
            }),
        };

        return (
            <div className={classes.root}>
                <NoSsr>
                    <Select
                        classes={classes}
                        styles={selectStyles}
                        options={this.state.options}
                        components={components}
                        id={this.state.value}
                        value={this.state.options.filter(({ id }) => id === this.state.value)}
                        onChange={this.handleChange('single')}
                        placeholder={this.props.valid ? this.props.placeholder : <span className={classes.danger}>Required</span>}
                    />
                </NoSsr>
            </div>
        );
    }
}

IntegrationReactSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    handleSelectData: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    valid: PropTypes.bool.isRequired,
    placeholder: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(IntegrationReactSelect);


// WEBPACK FOOTER //
// ./src/components/Common/IntegrationReactSelect.js